import { Link, useLocation } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { useAuth } from "../../../app/providers/AuthProvider";
import { FK } from "../../../capabilities/featureKeys";

export const accessButton =
  "inline-flex h-9 shrink-0 items-center justify-center gap-2 whitespace-nowrap rounded-lg border border-slate-200 bg-white px-3 text-sm font-normal text-slate-700 hover:bg-slate-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500/40 disabled:cursor-not-allowed disabled:opacity-50";
export const accessInput =
  "h-9 rounded-lg border border-slate-200 bg-white px-3 text-sm text-slate-700 outline-none focus:border-emerald-500 focus:ring-2 focus:ring-emerald-500/20";

export default function TeamAccessLayout({ children }) {
  const { can, hasAllAccess } = useAuth();
  const location = useLocation();
  const selectedTab = new URLSearchParams(location.search).get("tab") || "members";
  const tabLink = tab => {
    const query = new URLSearchParams(location.search);
    query.set("tab", tab);
    return { pathname: "/app/settings/team-management", search: `?${query}`, hash: location.hash };
  };
  const allowed = (key) => hasAllAccess || can?.(key);
  const tabs = [
    {
      label: "Team members",
      id: "members",
      visible: allowed(FK.SETTINGS_STAFF_MANAGEMENT),
    },
    {
      label: "Roles & permissions",
      id: "roles",
      visible: allowed(FK.SETTINGS_ROLE_PERMISSIONS_MAPPING),
    },
  ];
  return (
    <main className="min-h-full bg-slate-50 px-6 py-6 font-['Inter',ui-sans-serif,system-ui,sans-serif] text-sm text-slate-900">
      <div className="mx-auto max-w-[1320px] space-y-4">
        <header className="flex items-start gap-3">
          <span className="rounded-xl bg-emerald-600 p-2.5 text-white">
            <ShieldCheck size={21} aria-hidden="true" />
          </span>
          <div>
            <h1 className="text-xl font-semibold">Team Management</h1>
            <p className="mt-1 text-slate-500">
              Manage your team and the access each role provides.
            </p>
          </div>
        </header>
        <nav
          aria-label="Team and access"
          className="flex gap-5 border-b border-slate-200"
        >
          {tabs
            .filter((tab) => tab.visible)
            .map((tab) => (
              <Link
                key={tab.id}
                to={tabLink(tab.id)}
                aria-current={selectedTab === tab.id ? "page" : undefined}
                className={`border-b-2 px-1 py-3 ${selectedTab === tab.id ? "border-emerald-600 text-emerald-700" : "border-transparent text-slate-500 hover:text-slate-800"}`}
              >
                {tab.label}
              </Link>
            ))}
        </nav>
        {children}
      </div>
    </main>
  );
}
